import { useEffect, useState } from 'react'

import { Tile } from './tile'
import { Details } from './details'
import { Palette } from './palette'
import { Text, Trigger, MenuItems, MenuItem, Container } from './menu-styles'

const SECTIONS = ['palette', 'details']
export const Menu = ({ doCollide, onChange, config, color }) => {
  const [section, setSection] = useState(0)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    console.log({ color })
  }, [config])

  const setDetails = (e) => {
    setOpen(false)
    onChange('details', e)
  }

  const setColor = (color) => {
    setOpen(false)
    onChange('color', color)
  }

  const changeSection = (index) => {
    if (index >= SECTIONS.length) {
      index = 0
    }
    setSection(index)
  }

  return (
    <Container height={config.grid} open={open}>
      <Trigger onClick={() => setOpen(!open)}>
        <Tile
          background={color}
          position={{ width: config.grid, height: config.grid, x: 0, y: 0 }}
        >
          {doCollide ? '#' : null}
        </Tile>
        <Text onClick={() => setSection(0)}>Menu</Text>
      </Trigger>
      <MenuItems>
        <MenuItem $display={SECTIONS[section] === 'palette'}>
          <Palette onChange={setColor} />
        </MenuItem>
      </MenuItems>
    </Container>
  )
}
